import { MessageBar } from "@fluentui/react";
import styled from "styled-components";

export const StyledMessageBar = styled(MessageBar)`
  display: flex;
  align-items: center;
  padding: 4px 6px;
`;
